import request from '@/sheep/request';

// 自律项字段类型：0文本/1数字/2时间/3下拉选/4图片/5布尔开关
export type LimitProjectFieldType = 0 | 1 | 2 | 3 | 4 | 5;

// 自律项字段配置
export interface LimitProjectFields {
	id : number
	projectId ?: number
	fieldName ?: string
	fieldKey ?: string
	fieldType ?: LimitProjectFieldType
	isRequired ?: boolean
	sort ?: number
	defaultValue ?: string
	createTime ?: any
}

// 创建自律项字段配置
export const createLimitProjectFields = async (data : Partial<LimitProjectFields>) => {
	return request({
		url: '/wish/limit-project-fields/create',
		method: 'POST',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '创建成功'
		},
	});
}

// 更新自律项字段配置
export const updateLimitProjectFields = async (data : Partial<LimitProjectFields>) => {
	return request({
		url: '/wish/limit-project-fields/update',
		method: 'PUT',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '更新成功'
		},
	});
}

// 删除自律项字段配置
export const deleteLimitProjectFields = async (id : number) => {
	return request({
		url: '/wish/limit-project-fields/delete',
		method: 'DELETE',
		params: { id },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 批量删除自律项字段配置
export const deleteLimitProjectFieldsList = async (ids : number[]) => {
	return request({
		url: '/wish/limit-project-fields/delete-list',
		method: 'DELETE',
		params: { ids },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 获得自律项字段配置
export const getLimitProjectFields = async (id : number) => {
	return request({
		url: '/wish/limit-project-fields/get',
		method: 'GET',
		params: { id },
		custom: {
			auth: true
		},
	});
}

// 获得自律项字段配置分页
export const getLimitProjectFieldsPage = async (params : any) => {
	return request({
		url: '/wish/limit-project-fields/page',
		method: 'GET',
		params,
		custom: {
			auth: true
		},
	});
}
